export const fr = {
    titreOnglet: "Détail de la marge de crédit | Desjardins"
};
